import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bg-white rounded-lg p-2" }
const _hoisted_2 = { class: "flex flex-row gap-x-2 justify-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(this.filterOptions, (filter, index) => {
        return (_openBlock(), _createBlock("div", {
          key: index.toString(),
          class: "w-full cursor-pointer"
        }, [
          _createVNode("div", {
            class: ["w-full rounded-lg p-2 text-14px font-semibold text-center", `${_ctx.modelValue === filter.value ? 'bg-red-lp-100 text-white border-0' : 'bg-white text-gray-lp-600 border border-gray-lp-1600'}`],
            onClick: () => _ctx.onSelectFilter(filter.value)
          }, _toDisplayString(filter.label) + " " + _toDisplayString(_ctx.filterCounter(filter.value)), 11, ["onClick"])
        ]))
      }), 128))
    ])
  ]))
}